//@flow
import type { CountryType } from '../../../config/iddCountries';

export type IDDActionType =
  | {|
      type: 'SET_IDD_COUNTRY',
      payload: {|
        country: CountryType,
      |},
    |}
  | {|
      type: 'GO_TO_INTERNATIONAL_TOP_UP_OF_ZONE',
      payload: {|
        iddZone: string,
      |},
    |};

export const setIddCountry = (country: CountryType): IDDActionType => ({
  type: 'SET_IDD_COUNTRY',
  payload: { country },
});

export const goToInternationalTopUpOfZone = (iddZone: string): IDDActionType => ({
  type: 'GO_TO_INTERNATIONAL_TOP_UP_OF_ZONE',
  payload: {
    iddZone,
  },
});
